module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/plan4-1-d9fe38b9c595e9e464b6e5780d21f2b7.webp";